import type { ComponentProps } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

type NotificationBannerProps = ComponentProps<typeof DashboardCard2> & {
  cta: string;
  Icon: React.ReactNode;
  onPress: () => void;
};

export function ReminderBanner({
  children,
  cta,
  Icon,
  onPress,
  ...props
}: NotificationBannerProps) {
  return (
    <DashboardCard2
      classNameChildren="tw:items-center tw:flex-row tw:justify-between tw:flex tw:gap-4"
      {...props}
    >
      {Icon}

      <p className="body-md tw:mr-auto tw:ml-0 tw:max-w-2/5">
        <strong>{children}</strong>
      </p>

      <Button2
        className="tw:min-w-35"
        data-public="true"
        onPress={onPress}
        size="sm"
        variant="secondary"
      >
        {cta}
      </Button2>
    </DashboardCard2>
  );
}
